const relatedPostsIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_644_55)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60976 9.21951H1.53659V19.4634H4.60976V9.21951ZM1.53659 7.68293C0.687953 7.68293 0 8.37088 0 9.21951V19.4634C0 20.312 0.687953 21 1.53659 21H4.60976C5.45839 21 6.14634 20.312 6.14634 19.4634V9.21951C6.14634 8.37088 5.45839 7.68293 4.60976 7.68293H1.53659Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0366 9.21951H8.96341V19.4634H12.0366V9.21951ZM8.96341 7.68293C8.11478 7.68293 7.42683 8.37088 7.42683 9.21951V19.4634C7.42683 20.312 8.11478 21 8.96341 21H12.0366C12.8852 21 13.5732 20.312 13.5732 19.4634V9.21951C13.5732 8.37088 12.8852 7.68293 12.0366 7.68293H8.96341Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4634 9.21951H16.3902V19.4634H19.4634V9.21951ZM16.3902 7.68293C15.5416 7.68293 14.8537 8.37088 14.8537 9.21951V19.4634C14.8537 20.312 15.5416 21 16.3902 21H19.4634C20.312 21 21 20.312 21 19.4634V9.21951C21 8.37088 20.312 7.68293 19.4634 7.68293H16.3902Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.60976 1.53659H1.53659V5.12195H4.60976V1.53659ZM1.53659 0C0.687953 0 0 0.687953 0 1.53659V5.12195C0 5.97058 0.687953 6.65854 1.53659 6.65854H4.60976C5.45839 6.65854 6.14634 5.97058 6.14634 5.12195V1.53659C6.14634 0.687953 5.45839 0 4.60976 0H1.53659Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0366 1.53659H8.96341V5.12195H12.0366V1.53659ZM8.96341 0C8.11478 0 7.42683 0.687953 7.42683 1.53659V5.12195C7.42683 5.97058 8.11478 6.65854 8.96341 6.65854H12.0366C12.8852 6.65854 13.5732 5.97058 13.5732 5.12195V1.53659C13.5732 0.687953 12.8852 0 12.0366 0H8.96341Z"
        fill="#6B00DF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4634 1.53659H16.3902V5.12195H19.4634V1.53659ZM16.3902 0C15.5416 0 14.8537 0.687953 14.8537 1.53659V5.12195C14.8537 5.97058 15.5416 6.65854 16.3902 6.65854H19.4634C20.312 6.65854 21 5.97058 21 5.12195V1.53659C21 0.687953 20.312 0 19.4634 0H16.3902Z"
        fill="#6B00DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_644_55">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default relatedPostsIcon;
